import { Control, FieldPath, FieldValues } from 'react-hook-form';

import { FormField, FormItem, FormLabel } from '../ui/form';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

interface SelectFieldProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  placeholder: string;
  label: string;
  options: Option[];
}

interface Option {
  label: string;
  value: string;
}
const SelectField = <TFieldValues extends FieldValues>(props: SelectFieldProps<TFieldValues>) => {
  const { control, name, placeholder, label, options } = props;
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormItem>
            <FormLabel>{label}</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value} value={field.value}>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>{label}</SelectLabel>
                  {options.map(option => {
                    const { label, value } = option;
                    return (
                      <SelectItem value={value} key={value}>
                        {label}
                      </SelectItem>
                    );
                  })}
                </SelectGroup>
              </SelectContent>
            </Select>
          </FormItem>
        );
      }}
    />
  );
};

export default SelectField;
